<div class="flex relative">
	<label
		class="flex flex-1 w-4.5"
		[class.cursor-pointer]="!disabled()"
		[class.cursor-not-allowed]="disabled()"
	>
		@if (label()) {
			<div [class]="labelClasses()">
				{{ label() }}
			</div>
		}

		<input
			type="checkbox"
			class="peer h-4.5 w-4.5 absolute top-0 left-0 opacity-0"
			[class.cursor-not-allowed]="disabled()"
			[disabled]="disabled()"
			[checked]="checked()"
			(change)="toggleCheckbox()"
			(keydown)="onKeyDown($event)"
			[tabindex]="disabled() ? -1 : tabindex()"
		/>

		<span [class]="checkboxClasses()"></span>
	</label>
</div>
